import State from '@/classes/state';
import dealerSearchAppData from '@/utility/dealer-search-app-data';

if (!dealerSearchAppData) {
    throw new TypeError("Dealer search app variable is not available");
}

const { config, translations } = dealerSearchAppData;

if (!config) {
    throw new TypeError("Dealer search config is not available");
}

if (!translations) {
    throw new TypeError("Dealer search translations are not available");
}

// Create state
const state = new State({
    config,
    translations,
    filters: dealerSearchAppData.filters,
    markerIcons: dealerSearchAppData.markerIcons,
});

export default state;
